import { t as e } from "../../../v99990101-BAHO7XXd.js";
export { e as dashboardv99990101Client };
